exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toggle-switch input[type=\"checkbox\"]:disabled + label::before {\n  position: absolute;\n  display: inline-block;\n  content: '';\n  height: 18px;\n  width: 33px;\n  border-radius: 9px;\n  border: 2px solid #eeeeee;\n  background-color: #eeeeee;\n  top: 3px;\n  right: -42px;\n  transition: .15s ease-in;\n  transition-property: border-color, background-color; }\n\n.toggle-switch input[type=\"checkbox\"]:disabled + label::after {\n  display: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/views/site-admin/site-setup/cat-setup/components/toggle-item/toggle-item.component.scss
// module id = ../../../../../src/app/views/site-admin/site-setup/cat-setup/components/toggle-item/toggle-item.component.scss
// module chunks = main